var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        }
      }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v(_vm._s(_vm.formTitle))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c(
          "div",
          {
            staticClass: "form-group",
            class: { "has-error": _vm.errors.name }
          },
          [
            _c("label", { attrs: { for: "subgroup-name" } }, [_vm._v("Name")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.name,
                  expression: "form.name"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", id: "subgroup-name" },
              domProps: { value: _vm.form.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form, "name", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.name
              ? _c("p", { staticClass: "help-block" }, [
                  _vm._v(_vm._s(_vm.errors.name))
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-group",
            class: { "has-error": _vm.errors.type }
          },
          [
            _c("label", { attrs: { for: "subgroup-type" } }, [_vm._v("Type")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.typeSelection,
                    expression: "typeSelection"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "subgroup-type" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.typeSelection = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.handleTypeChange
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [
                  _vm._v("-- Select Type --")
                ]),
                _vm._v(" "),
                _vm._l(_vm.defaultTypes, function(type) {
                  return _c(
                    "option",
                    { key: type.value, domProps: { value: type.value } },
                    [_vm._v(_vm._s(type.label))]
                  )
                }),
                _vm._v(" "),
                _c("option", { attrs: { value: "custom" } }, [
                  _vm._v("Custom...")
                ])
              ],
              2
            ),
            _vm._v(" "),
            _vm.typeSelection === "custom"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.type,
                      expression: "form.type"
                    }
                  ],
                  staticClass: "form-control custom-type",
                  attrs: {
                    type: "text",
                    id: "subgroup-type-custom",
                    placeholder: "Enter custom type",
                    maxlength: "64",
                    "aria-label": "Enter custom type"
                  },
                  domProps: { value: _vm.form.type },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "type", $event.target.value)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.errors.type
              ? _c("p", { staticClass: "help-block" }, [
                  _vm._v(_vm._s(_vm.errors.type))
                ])
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-default",
            attrs: { type: "button" },
            on: { click: _vm.cancel }
          },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "submit", disabled: _vm.saving }
          },
          [_vm._v(_vm._s(_vm.saving ? "Saving..." : "Save"))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }